import React from "react";
import { View, Text } from "react-native";
import { Avatar } from "../ui/avatar";
import { Button } from "../ui/button";
import SubjectIcon from "@/assets/svgs/subject-icon";
import { useRouter } from "expo-router";
import { Id } from "@teachloop/backend/_generated/dataModel";
import { useFormatDate } from "@/elements/hooks/use-format-date";
import SubjectReviewIcon from "@/assets/svgs/subject-review-icon";

export type LessonHistoryItemData = {
  _id: Id<"lessonReports">;
  status: "pending" | "completed" | "failed" | "in_progress" | "pending_review";
  completedAt: number | undefined;
  tutor: {
    firstName: string | undefined;
    imageUrl: string | null;
  };
};

type LessonHistoryItemProps = {
  item: LessonHistoryItemData;
};

function LessonHistoryItem({ item }: LessonHistoryItemProps) {
  const fmt = useFormatDate();
  const router = useRouter();

  return (
    <View className="flex-row py-3 items-center">
      <View className="flex-row items-center gap-2 flex-1">
        <Avatar size="sm">
          <Avatar.Content
            labelSize="sm"
            size="sm"
            label={item.tutor.firstName}
            source={
              item.tutor.imageUrl ? { uri: item.tutor.imageUrl } : undefined
            }
          />
        </Avatar>

        <Text className="font-geologica-medium font-medium text-base text-gray-800 leading-[1.5]" numberOfLines={1}>
          {item.tutor.firstName}
        </Text>

        <Text className="font-geologica-regular font-normal text-base text-gray-800 leading-[1.5]" numberOfLines={1}>
          {item.completedAt ? fmt(item.completedAt, "do MMMM") : ""}
        </Text>
      </View>

      <Button
        size="sm"
        borderLess
        icon
        className="py-0"
        onPress={() => {
          router.navigate(`/(app)/lesson-history/${item._id}`);
        }}
      >
        <Button.Icon
          as={
            item.status === "pending_review" ? SubjectReviewIcon : SubjectIcon
          }
          pathClassName={
            item.status === "pending_review"
              ? "fill-teachLoop-accentPrimary"
              : "stroke-teachLoop-accentPrimary stroke-2"
          }
        />
        <Button.Text size="sm" intent="primary">
          {item.status === "pending_review" ? "Review report" : "View report"}
        </Button.Text>
      </Button>
    </View>
  );
}

export default LessonHistoryItem;
